import { render, staticRenderFns } from "./UserChip.vue?vue&type=template&id=0db54f70"
import script from "./UserChip.vue?vue&type=script&lang=js"
export * from "./UserChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports